import React, { useState, useEffect } from "react";
import Menu from "../Menu";
import { http } from "../../services/http";
import { useAlert } from "react-alert";
import { PagingState, EditingState, CustomPaging, FilteringState } from "@devexpress/dx-react-grid";
import { Grid, Table, TableHeaderRow, PagingPanel, TableEditRow, TableEditColumn, TableFilterRow, TableColumnVisibility, TableFixedColumns } from "@devexpress/dx-react-grid-material-ui";
import { QueryString, Create, Update, Remove, ExportXlsx, TIMER_FILTER, APPNAME_AUTOMACAOCARGAHIAE } from "../utils/react_grid_utils";
import { editColumnMessages } from "../utils/react_grid_edit_command_localization";
import Import from "../utils/import";
import authenticatedUserContext from "../security/AuthenticatedUserContext";
import Header from "../Header";
import { ProcedimentoHiaeTypeProvider } from "../utils/react_grid_procedimento_hiae_column";
import { CodigoD2iHiaeTypeProvider } from "../utils/react_grid_codigo_d2i_hiae_column";

const getRowId = (row) => row.id;
const api_resource = "carga-hiae/de-para-procedimentos";


export default function DeParaProcedimentosHIAETable() {
  const alert = useAlert();

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize] = useState(10);
  const [totalItens, setTotalItens] = useState(10);
  const [rows, setRows] = useState([]);
  const [tableColumnExtensions] = useState([
    { columnName: "id", width: 60 },
    { columnName: "codigo_hiae", width: 400 },
    { columnName: "procedimento", width: 400 },
    { columnName: "codigo_d2i", width: 350 },
  ]);
  const [filteringStateColumnExtensions] = useState([]);
  const [defaultHiddenColumnNames] = useState(["id"]);
  const [editingRowIds, setEditingRowIds] = useState([]);
  const [addedRows, setAddedRows] = useState([]);
  const [rowChanges, setRowChanges] = useState({});
  const [filtersApi, setFiltersApi] = useState([]);

  // Armazena temporariamente os valores relacionados
  const [tempRelatedValues, setTempRelatedValues] = useState({});

  // Expõe as funções globalmente para os componentes de autocomplete
  useEffect(() => {
    window.updateRowField = (rowId, fieldName, value) => {
      console.log('updateRowField chamado:', { rowId, fieldName, value });

      if (rowId === 0 || rowId === undefined || rowId === null) {
        // É uma nova linha - armazena temporariamente
        console.log('Armazenando valor temporário para nova linha');
        setTempRelatedValues(prev => ({
          ...prev,
          [fieldName]: value
        }));
      } else {
        // É uma linha existente
        setRowChanges(prev => {
          console.log('Atualizando rowChanges para linha existente:', prev);
          const currentChanges = prev[rowId] || {};
          return {
            ...prev,
            [rowId]: {
              ...currentChanges,
              [fieldName]: value
            }
          };
        });
      }
    };

    return () => {
      delete window.updateRowField;
    };
  }, []);

  // Aplica valores temporários quando eles mudam
  useEffect(() => {
    if (Object.keys(tempRelatedValues).length > 0) {
      console.log('Valores temporários mudaram:', tempRelatedValues);

      // Para novas linhas
      if (addedRows.length > 0) {
        console.log('Aplicando valores temporários às linhas adicionadas');
        setAddedRows(prev => prev.map(row => ({
          ...row,
          ...tempRelatedValues
        })));
      }

      // Para linhas em edição - força atualização do rowChanges
      if (Object.keys(rowChanges).length > 0) {
        console.log('Aplicando valores temporários ao rowChanges');
        setRowChanges(prev => {
          const updated = {};
          Object.keys(prev).forEach(rowId => {
            updated[rowId] = {
              ...prev[rowId],
              ...tempRelatedValues
            };
          });
          return updated;
        });
      }
    }
  }, [tempRelatedValues]);

  function get(page, filters) {
    const queryString = QueryString(page, pageSize, filters);
    http.get(api_resource + queryString).then(
      (response) => {

        addRows(response?.data?.data);
        setTotalItens(response?.data?.total);
      },
      (error) => {
        console.log(error);
      }
    );
  }


  function addRows(rows)
  {
    setRows(rows);
  }

  useEffect(() => {
    get(0, []);
  }, []);

  const [timer, setTimer] = useState(null);

  function handleFilters(filters) {
    clearTimeout(timer);
    setFiltersApi(filters);

    setTimer(
      setTimeout(function () {
        get(pageIndex, filters);
      }, TIMER_FILTER)
    );
  }

  function handlePage(page) {
    setPageIndex(page);
    get(page, filtersApi);
  }

  const changeAddedRows = (value) => {
    console.log('changeAddedRows chamado:', value);
    console.log('Valores temporários:', tempRelatedValues);

    const initialized = value.map((row) => {
      if (Object.keys(row).length) {
        // Aplica os valores temporários se existirem
        const updatedRow = { ...row, ...tempRelatedValues };
        console.log('Linha com valores aplicados:', updatedRow);
        return updatedRow;
      }
      return {};
    });

    setAddedRows(initialized);
    // Limpa os valores temporários após aplicar
    if (initialized.length > 0 && Object.keys(initialized[0]).length > 0) {
      setTempRelatedValues({});
    }
  };

  const handleRowChanges = (changes) => {
    console.log('handleRowChanges:', changes);
    console.log('Valores temporários para aplicar:', tempRelatedValues);

    // Mescla os valores temporários com as mudanças
    const updatedChanges = { ...changes };

    if (Object.keys(tempRelatedValues).length > 0) {
      // Para cada linha em edição, aplica os valores temporários
      Object.keys(updatedChanges).forEach(rowId => {
        updatedChanges[rowId] = {
          ...updatedChanges[rowId],
          ...tempRelatedValues
        };
      });

      // Limpa os valores temporários
      setTimeout(() => setTempRelatedValues({}), 100);
    }

    console.log('Mudanças finais:', updatedChanges);
    setRowChanges(updatedChanges);
  };

  const commitChanges = ({ added, changed, deleted }) => {
    let changedRows;
    if (added) {
      // Adiciona alpha como null
      const dataToSend = { ...added[0], alpha: null };
      Create(api_resource, dataToSend, alert).then((response) => {
        var new_row = response.data[0];
        const startingAddedId = rows.length > 0 ? rows[rows.length - 1].id + 1 : 0;
        changedRows = [
          ...added.map((row, index) => ({
            id: startingAddedId + index,
            ...new_row,
          })),
          ...rows,
        ];
        setRows(changedRows);
      });
    }
    if (changed) {
      changedRows = rows.map((row) => (changed[row.id] ? { ...row, ...changed[row.id] } : row));
      var item = changedRows.find((row) => changed[row.id]);
      // Garante que alpha seja sempre null
      item.alpha = null;

      Update(api_resource, item, alert);
      setRows(changedRows);
    }
    if (deleted) {
      var confirmado = window.confirm("Confirma a exclusão?");
      if (confirmado === true) {
        Remove(api_resource, deleted[0], alert);
        console.log(deleted);
        const deletedSet = new Set(deleted);
        changedRows = rows.filter((row) => !deletedSet.has(row.id));
      } else {
        changedRows = rows;
      }
      setRows(changedRows);
    }
  };

  var columns = [
    { name: "id", title: "ID" },
    { name: "codigo_hiae", title: "Procedimento HIAE" },
    { name: "procedimento", title: "Procedimento D2I" },
    { name: "codigo_d2i", title: "Código D2I" },
  ];

  const [procedimentoColumns] = useState(["procedimento"]);
  const [codigoD2iColumns] = useState(["codigo_d2i"]);


  return (
    <div id="wrapper">
      <Menu />
      <div id="page-wrapper" className="gray-bg">
        <Header/>
        <div className="row wrapper border-bottom white-bg page-heading">
          <div className="col-lg-10">
            <h2>De-Para Procedimentos HIAE</h2>
          </div>
          <div className="col-lg-2">
            <button className="btn btn-primary btn-sm" style={{ marginTop: "20px" }} type="button" onClick={() => ExportXlsx(api_resource, alert)}>
              Exportar
            </button>
            <Import api_resource={api_resource} alert={alert} appname={APPNAME_AUTOMACAOCARGAHIAE} excluir={true} onFinish={() => get([0], [])} />
          </div>
        </div>
        <div className="wrapper wrapper-content animated fadeInRight">
          <div className="row">
            <div className="col-lg-12">
              <div className="ibox ">
                <div className="ibox-content">
                  <Grid rows={rows} columns={columns} getRowId={getRowId}>
                    <PagingState currentPage={pageIndex} pageSize={pageSize} onCurrentPageChange={handlePage} />
                    <EditingState editingRowIds={editingRowIds} onEditingRowIdsChange={setEditingRowIds} rowChanges={rowChanges} onRowChangesChange={handleRowChanges} addedRows={addedRows} onAddedRowsChange={changeAddedRows} onCommitChanges={commitChanges} columnExtensions={tableColumnExtensions} />
                    <FilteringState onFiltersChange={handleFilters} columnExtensions={filteringStateColumnExtensions}/>
                    <ProcedimentoHiaeTypeProvider for={procedimentoColumns} />
                    <CodigoD2iHiaeTypeProvider for={codigoD2iColumns} />
                    <Table columnExtensions={tableColumnExtensions} />
                    <TableHeaderRow />
                    <TableColumnVisibility defaultHiddenColumnNames={defaultHiddenColumnNames} />
                    <TableEditRow />
                    {authenticatedUserContext.allow_edit(APPNAME_AUTOMACAOCARGAHIAE) === true ? <TableEditColumn showAddCommand={!addedRows.length} showEditCommand showDeleteCommand messages={editColumnMessages} /> : <></>}
                    <CustomPaging totalCount={totalItens} />
                    <PagingPanel />
                    <TableFilterRow />
                    <TableFixedColumns leftColumns={[TableEditColumn.COLUMN_TYPE]} />
                  </Grid>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
